export default "__VITE_ASSET__P8kzpOih__"